import QuestionBlock from "../components/QuestionBlock";
import SectionCard from "../components/SectionCard";
import "../styles/style.css";

export default function Step7 ({ data, onChange, onNext, onBack }) {

    const isValid =
    data.quantasVezesCriancaAdolescentesAlimentamDia &&
    data.rotinaAlimentacaoFora;
   

  return (
    <>
    <SectionCard
          title="Alimentação / Nutrição"
          description="Responda às perguntas abaixo com atenção. Suas respostas são confidenciais e serão utilizadas exclusivamente para fins educacionais."
          items={[
            { icon: "bi bi-building", text: "Escola Mun. Gov. Moura Cavalcanti" }
          ]}
        > </SectionCard>

      <QuestionBlock
        name="quantasVezesCriancaAdolescentesAlimentamDia"
        title="Quantas vezes a criança/adolescente se alimenta por dia?"
        subtitle="(Resposta única)"
        options={[
          "1 a 2 vezes",
          "3 a 4 vezes",
          "5 a 6 vezes",
          "mais de 6 vezes"
        ]}
        selected={data.quantasVezesCriancaAdolescentesAlimentamDia}
        onSelect={(value) => onChange({ quantasVezesCriancaAdolescentesAlimentamDia: value })}
      />
      <QuestionBlock
        name="rotinaAlimentacaoFora"
        title="A rotina alimentar da criança quando está fora da escola é:"
        subtitle="(Resposta única)"
        options={[
          "Boa",
          "Regular",
          "Ruim"
        ]}
        selected={data.rotinaAlimentacaoFora}
        onSelect={(value) => onChange({ rotinaAlimentacaoFora: value })}
      />
      <div className="nav-buttons">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>

        <button
          className="btn btn-primary"
          onClick={onNext}
          disabled={!isValid}
        >
          Próximo
        </button>
      </div>
    </>
  );
}
